export default __webpack_public_path__ + "static/59287-9591b3c244a5c92072e2c2755910c557.jpg";